import React from "react"
import Footer from "../Components/Footer";
import schoolgate from "../Assets/schoolgate.jpg";
import verificarion from "../Assets/verification.png";
import ict_building from "../Assets/ict_building.jpg";

const facilities = [
    "Administrative block hosting 14 offices and a mini-conference room with internet ports.",
    "Spacious examination hall with 140-seat capacity and internet ports.",
    "E-library with over 5,000 hard copies across medical fields, 108-seat capacity, and 36 laptops loaded with 10,000+ digital titles.",
    "A newly completed Pharmacy Department with 6 well-aerated classrooms (100-student capacity each), 14 offices, a staff common room, and 23 water closets.",
    "Science block with fully equipped physics and chemistry laboratories and 8 furnished offices.",
    "Standard canteen with 28-seat capacity.",
    "Fully equipped Pharmacy Laboratory with state-of-the-art facilities.",
    "World-class Biology demonstration room with anatomical charts, models, and simulators, plus a demonstration ground with incinerator, abattoir, and underwater well models.",
    "Audio-visual room with photo-makers, magnifiers, cutters, and mobile/overhead projectors.",
    "Environmental Health museum.",
    "Professor Olukoye Ransome-Kuti's block (Community Health Block) with 5 classrooms (100-student capacity each) and 4 offices.",
    "9 additional classrooms, well aerated and illuminated, each with 100-student capacity.",
    "Borehole with 20,500-litre overhead tank capacity, reticulating the entire school.",
    "Connected to the National Grid, with backup from 25 KVA, 100 KVA, and departmental generating plants.",
    "School PHC clinic with 8-bed capacity, GOPD, labour room, consulting rooms, family planning unit, and pharmacy/dispensary — with referral to Owoche Clinic and Maternity Home at Itekpa, Bekwarra.",
    "2 male hostels, 4 female hostels, and staff quarters, with a 160-capacity female hostel under construction.",
    "Student laundry unit and kitchen.",
    "Recreational facilities for indoor and outdoor games, including full male and female football teams.",
    "Secured with a perimeter fence and security personnel linked to conventional security organizations.",
    "A new administrative block with 12 offices, a 5,000-capacity auditorium, a 72-capacity ICT unit, and a CBT centre with 60 Mbps internet.",
];

const accreditations = [
    "Environmental Health Officers Registration Council of Nigeria (EHORECON)",
    "West African Health Examination Board (WAHEB)",
    "Health Record Officers Registration Board of Nigeria (HRORBN) — fully accredited",
    "Community Health Practitioners Registration Board of Nigeria (CHPRBN) — fully accredited",
    "Medical Laboratory Science Council of Nigeria (MLSCN) — fully accredited",
    "Optometrist and Dispensing Optician Registration Board of Nigeria",
];

const Aboutp = () => {
    return (
        <div className="pt-20 bg-[#F6F5F1]" style={{ fontFamily: "'Inter', sans-serif" }}>

            {/* Header banner */}
            <div
                className="relative w-full h-72 md:h-80 bg-cover bg-center"
                style={{ backgroundImage: `url(${schoolgate})` }}
            >
                <div className="absolute inset-0 bg-[#12213D]/80 flex flex-col justify-center px-4 md:px-10 lg:px-16">
                    <div className="flex items-center gap-2 mb-4">
                        <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                        <span className="text-[#B8862E] text-sm">Owoche College of Health Sciences and Technology</span>
                    </div>
                    <h1
                        className="text-[#F6F5F1] text-4xl md:text-5xl"
                        style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                    >
                        About us
                    </h1>
                </div>
            </div>

            {/* Story */}
            <div className="flex flex-col md:flex-row my-20 justify-between px-4 md:px-10 lg:px-16 gap-10 md:gap-16 items-center">
                <div className="w-full md:w-1/2">
                    <div className="flex items-center gap-2 mb-5">
                        <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                        <span className="text-[#B8862E] text-sm">Our story</span>
                    </div>
                    <p className="text-[#5B6472] leading-relaxed">
                        Owoche College of Health Sciences and Technology, Bewo, Bekwarra, was established under the Companies and Allied Matters Act of 1990 on 24th October, 2013, with a vision to be a training institution of excellence with a clear focus on producing relevant and competent graduates, capable of providing efficient modern primary healthcare services. Its mission is to produce highly committed community and public health practitioners for the primary healthcare tier of the health services, in an environment of the highest-quality teaching and learning, compatible with patient-centered community practice — with a philosophy of producing graduates who are scientifically, vocationally, academically, and ethically committed to preventing illness as a first priority.
                    </p>
                </div>
                <div className="w-full md:w-1/2">
                    <img src={schoolgate} className="w-full h-64 md:h-80 object-cover rounded-sm border border-[#12213D]/10" alt="School gate" />
                </div>
            </div>

            {/* Campus */}
            <div className="flex flex-col md:flex-row my-20 justify-between px-4 md:px-10 lg:px-16 gap-10 md:gap-16 items-center">
                <div className="w-full md:w-1/2 hidden md:block">
                    <img src={ict_building} className="w-full h-80 object-cover rounded-sm border border-[#12213D]/10" alt="ICT building" />
                </div>
                <div className="w-full md:w-1/2">
                    <div className="flex items-center gap-2 mb-5">
                        <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                        <span className="text-[#B8862E] text-sm">Our campus</span>
                    </div>
                    <p className="text-[#5B6472] leading-relaxed">
                        The campus sits about 400 km from Calabar, the state capital, on a site with over 15 hectares of land. As a rural area with a strong quest for educational development, there was a clear need for a tertiary institution in the medical and allied professions — leading to the establishment of Owoche College of Health Sciences and Technology, to train middle-level manpower for the health sector.
                    </p>
                </div>
                <div className="w-full md:w-1/2 block md:hidden">
                    <img src={ict_building} className="w-full h-64 object-cover rounded-sm border border-[#12213D]/10" alt="ICT building" />
                </div>
            </div>

            {/* Facilities & accreditation */}
            <div className="px-4 md:px-10 lg:px-16 my-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">

                    <div>
                        <h2
                            className="text-2xl text-[#12213D] mb-3"
                            style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                        >
                            Facilities
                        </h2>
                        <p className="text-[#5B6472] text-sm mb-8 max-w-md">
                            The college is designed with a serene environment and tastefully furnished infrastructure, including:
                        </p>
                        <ul className="flex flex-col gap-4">
                            {facilities.map((item, i) => (
                                <li key={i} className="flex items-start gap-3">
                                    <img src={verificarion} className="w-5 h-5 object-cover rounded-full mt-0.5 shrink-0" alt="" />
                                    <p className="text-sm text-[#5B6472] leading-relaxed">{item}</p>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:border-l md:border-[#12213D]/10 md:pl-16">
                        <h2
                            className="text-2xl text-[#12213D] mb-3"
                            style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                        >
                            Accreditations
                        </h2>
                        <p className="text-[#5B6472] text-sm mb-8 max-w-md">
                            We have attained the following accreditations:
                        </p>
                        <ul className="flex flex-col gap-4">
                            {accreditations.map((item, i) => (
                                <li key={i} className="flex items-start gap-3">
                                    <img src={verificarion} className="w-5 h-5 object-cover rounded-full mt-0.5 shrink-0" alt="" />
                                    <p className="text-sm text-[#5B6472] leading-relaxed">{item}</p>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Aboutp;